$(document).ready(function() {
$(".btabs li").click(function(){
  $(this).siblings().removeClass("active")
  $(this).addClass("active") 
})
});
